module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (_vm.sortedActiveMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("marker.active")))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedActiveMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "tag": "button",
      "to": {
        path: '/marker/edit'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("marker.add")) + "\n      ")])], 1)]), _vm._v(" "), (_vm.sortedFutureMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("marker.future")))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedFutureMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.sortedPastMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('marker.past')))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedPastMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.amountPages,
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchMarkersData()
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea1f3e9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarkersList.vue
// module id = 1073
// module chunks = 1